import { getTimeTillEndOfDayMs } from '@helpers';
import { useQuery } from '@tanstack/react-query';

import {
  fetchKeyValues,
  fetchKeyValuesV3,
} from '../../services/entity-report-service';

export const QUERY_KEY_VALUES = 'QUERY_KEY_VALUES';
export const useKeyValues = ({
  entityTag,
  isApiEntityKeyValuesEnabled,
}: {
  entityTag: string;
  isApiEntityKeyValuesEnabled: boolean;
}) => {
  const fetchFn = isApiEntityKeyValuesEnabled
    ? fetchKeyValuesV3
    : fetchKeyValues;
  return useQuery({
    queryKey: [QUERY_KEY_VALUES, entityTag, isApiEntityKeyValuesEnabled],
    queryFn: ({ signal }) => fetchFn(entityTag, signal),
    staleTime: getTimeTillEndOfDayMs(),
  });
};
